import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import './styles.css';

class AMPlusFiltersPage extends React.PureComponent {
  static propTypes = {
    intl: PropTypes.object,
  };

  render() {
    /* eslint-disable no-unused-vars */
    const { intl } = this.props;

    return (
      <div styleName="container">
        Page for View Filters and Edit Filters
      </div>
    );
  }
}

export default injectIntl(AMPlusFiltersPage);
